import { render, staticRenderFns } from "./configGuessNum.vue?vue&type=template&id=2cd51350&"
import script from "./configGuessNum.vue?vue&type=script&lang=js&"
export * from "./configGuessNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports